module.exports = __webpack_public_path__ + "static/media/nepal-village.fd2d4958.jpg";